export const setEnvCookie = value => {
  const expiration_date = new Date();
  let cookie_string = '';
  expiration_date.setFullYear(expiration_date.getFullYear() + 10);
  cookie_string = `env=${
    value ? 'Production' : 'Sandbox'
  }; path=/; expires=${expiration_date.toUTCString()}`;
  document.cookie = cookie_string;
};
